class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.opened = false;

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");
    this.predictiveSearchCollection = this.querySelector(
      "#predictive-search-collection"
    );
    this.predictiveSearchCollectionHeader =
      this.querySelector(".slider-header");
    
    this.closeButton = this.querySelector("#close-btn");
    this.predictiveSearchOverlay = this.querySelector("[data-ps-overlay]");
    
    this.predictiveSearchCollectionHeaderInit = this.querySelector(".slider-header").innerHTML;

    // open the predictive search when the input is focused
    this.input.onfocus = () => {
      this.open();
    };

    // close the predictive search
    this.closeButton.onclick = (e) => {
      e.preventDefault();
      this.close();
    };

    this.predictiveSearchOverlay.onclick = (e) => {
      e.preventDefault();
      this.close();
    };

    
    this.removeFocus = function() {
      if (this.opened) {
        this.input.blur();
        this.input.dispatchEvent(new Event('blur'));
      }
    }
    window.addEventListener('touchmove', this.removeFocus.bind(this));

    

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }
  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.predictiveSearchCollectionHeader.innerHTML = this.predictiveSearchCollectionHeaderInit;
      this.predictiveSearchResults.innerHTML = this.predictiveSearchCollection.outerHTML;
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `${predictiveSearchRoute}?q=${searchTerm}&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        const productsCount = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("[data-ps-count]")
          .getAttribute("data-ps-count");

        if (productsCount == 0) {
          const noResultsHeader = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("[data-ps-no-results]").outerHTML;

          this.predictiveSearchCollectionHeader.innerHTML = noResultsHeader;
          this.predictiveSearchResults.innerHTML =
            this.predictiveSearchCollection.outerHTML;
        } else {
          this.predictiveSearchResults.innerHTML = resultsMarkup;
        }
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.opened = true;
    const headerTopBar = document.querySelector(".header__top-bar").offsetHeight,
          headerToolBar = document.querySelector(".toolbar-section").offsetHeight,
          headerHeight = headerTopBar + headerToolBar;

    // I need this only when I fishish the predictive search
    document.scrollingElement.scrollTop = 0;
    document.scrollingElement.style.height = window.innerHeight + "px";
    document.scrollingElement.style.position = "fixed";
    document.scrollingElement.style.overflow = "hidden";
    this.predictiveSearchResults.style.top = headerHeight + "px";
    this.predictiveSearchResults.style.height = `calc(100dvh - ${headerHeight}px)`;
    this.predictiveSearchResults.classList.add("show");
    this.closeButton.classList.add("show");
    this.predictiveSearchOverlay.style.height = `${headerHeight}px`
    this.predictiveSearchOverlay.classList.add("show");
  }

  close() {
    this.opened = false;
    // I need this only when I fishish the predictive search
    document.scrollingElement.style.height = "auto";
    document.scrollingElement.style.position = "initial";
    document.scrollingElement.style.overflow = "initial";
    // this.predictiveSearchResults.style.display = "none";
    this.predictiveSearchResults.classList.remove("show");
    this.closeButton.classList.remove("show");
    this.predictiveSearchOverlay.classList.remove("show");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
